import React, { useState } from 'react';
import moment from 'moment';
import { Box, Card, Typography } from '@mui/material';
import { getMarkerMap } from '../../maps/utils';
import getUsersName from '../../../../helpers/users/utils';

const LocationAnomalyDetails = ({ event }) => {
    const markerMap = getMarkerMap();
    const { type, user_id, date } = event;

    if (!(type in markerMap)) return null;

    const [showInfo, setShowInfo] = useState(false);
    const driverName = getUsersName(user_id);
    const { label, marker } = markerMap[type];

    const handleMouseEnter = () => {
        setShowInfo(true);
    };

    const handleMouseLeave = () => {
        setShowInfo(false);
    };

    return (
        <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Box sx={{ zIndex: 1 }}>{marker}</Box>
            {showInfo && (
                <Card
                    sx={{
                        position: 'absolute',
                        left: 25,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 50,
                        // wrap
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            margin: '8px',
                            width: '150px',
                            // wrap
                        }}
                    >
                        <Typography variant="subtitle2">{label}</Typography>
                        {driverName && <Typography variant="p">{driverName}</Typography>}
                        <Typography variant="p">{moment(date).format('MMMM Do, YYYY - h:mm a')}</Typography>
                    </Box>
                </Card>
            )}
        </Box>
    );
};

export default LocationAnomalyDetails;
